import {
  GetIntegrationAgencySettingsResponseTO,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import { PropertyBusinessType } from 'models/Properties';
import { PropertyForPropertyListItem } from 'pages/agencyProperties/Properties.types';
import PaginatedPropertiesScroll from './PaginatedPropertiesScroll';
import PropertyListItem from './propertyListItem/PropertyListItem';

interface PropertiesResultsProps {
  integrationAgencySettings: GetIntegrationAgencySettingsResponseTO;
}

const PropertiesResults = ({
  integrationAgencySettings,
}: PropertiesResultsProps) => {
  const isPointCentralIntegration =
    integrationAgencySettings.enumId === IntegrationEnum.POINTCENTRAL;

  const filterProperties = (properties: PropertyForPropertyListItem[]) => {
    if (!isPointCentralIntegration) {
      return properties;
    }

    return properties.filter(
      (property) => property.businessType !== PropertyBusinessType.HOTEL,
    );
  };

  return (
    <PaginatedPropertiesScroll
      integrationAgencySettings={integrationAgencySettings}
      emptyMessage="pageIntegrations.integrationDetails.noPropertiesFound"
      PropertyListItem={PropertyListItem}
      filterProperties={filterProperties}
    />
  );
};

export default PropertiesResults;
